module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dd55f4c6c20f5d25e520b6f5bfb090c5.svg";